/*
  Green Hunters, gh-header.js
  Reine Ergaenzung fuer Desktop (>= 990px): oeffnet das Dawn-Mega-Menue schon
  beim Hovern, nicht erst beim Klick. Es werden nur mouseenter/mouseleave
  ergaenzt und das open-Attribut der details.mega-menu gesetzt bzw. nach einer
  kurzen Verzoegerung (gegen Flackern) wieder entfernt. Dawns eigenes Klick- und
  Tastatur-Verhalten (HeaderMenu/global.js) bleibt vollstaendig unangetastet,
  damit die Accessibility erhalten bleibt. Keine Dawn-JS-Datei wird veraendert.
  Als IIFE gewrappt, mit defer geladen.
*/
(function () {
  'use strict';

  var DESKTOP = window.matchMedia('(min-width: 990px)');
  var CLOSE_DELAY = 150;

  function bind(menu) {
    var details = menu.querySelector('details.mega-menu');
    if (!details) return;

    var closeTimer = null;

    function cancelClose() {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
    }

    menu.addEventListener('mouseenter', function () {
      if (!DESKTOP.matches) return;
      cancelClose();
      if (!details.open) {
        details.setAttribute('open', '');
      }
    });

    menu.addEventListener('mouseleave', function () {
      if (!DESKTOP.matches) return;
      cancelClose();
      closeTimer = setTimeout(function () {
        details.removeAttribute('open');
        closeTimer = null;
      }, CLOSE_DELAY);
    });
  }

  function init() {
    var menus = document.querySelectorAll('.header__inline-menu header-menu');
    for (var i = 0; i < menus.length; i++) {
      bind(menus[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
